<template>
  <div class="tree-select">
    <a-row :gutter="48" type="flex">
      <a-col :span="12" class="divide">
        <a-row>
          <a-col>
            <a-input placeholder="请输入关键词" v-model="keyword" @change="filterKeyword(data, 'searchData', keyword, params.title, params.children)"></a-input>
          </a-col>
          <a-col>
            <a-tree block-node :load-data="loadData" :check-strictly="checkStrictly" checkable :selectable="false" :checked-keys="value.map(val => val[params.key])" 
						:tree-data="keyword ? searchData : data" :replaceFields="params" @check="handleCheck" @load="handleLoad">
              <template slot="title" slot-scope="row">
                <slot v-bind:row="row">{{row.name}}</slot>
              </template>
            </a-tree>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="12">
        <div class="app-list">
          <div class="item" v-for="(m, n) in value" :key="n">
            <div>{{m.full_name}}</div>
            <div @click="del(n)"><dy-icon type="icon-delete"></dy-icon></div>
          </div>
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
  export default {
    name: 'TreeSelect',
    props: {
      data: {
        type: Array,
        default: []
      },
      params: {
        type: Object,
        default: {}
      },
      value: {
        type: Array,
        default: []
      },
      multiple: {
        type: Boolean,
        default: false
      },
      checkStrictly: {
        type: Boolean,
        default: true
      },
      loadData: {
        type: Function,
        default: null
      }
    },
    data() {
      return {
        treeSelectValue: [],
        keyword: null,
        searchData: [],
        checkedItems: []
      }
    },
    watch: {
      data: {
        handler(newValue, oldValue) {
          if (newValue.length) {
            this.initPath(newValue);
          }
          if (this.value.length) {
            this.value.forEach((value, index) => {
              value.nodePath = [];
              this.$depthSearchTree(node => {
                if (node[this.params.key] === value[this.params.key]) {
                  this.$set(this.value, index, node);
                }
              }, this.data);
            });
          }
        },
        immediate: true
      },
    },
    methods: {
      initPath(data, parent) {
        data.forEach(val => {
          if (parent) {
            val.nodePath = [...parent.nodePath, {
              [this.params.title]: parent[this.params.title],
              [this.params.key]: parent[this.params.key]
            }];    
          } else {
            val.nodePath = [];
          }
          val.full_name = val.nodePath.map(val => val[this.params.title]).concat([val[this.params.title]]).join('-');
          if (val.children && val.children.length) {
            this.initPath(val.children, val);
          }
        });
      },
      handleLoad(loadKeys, e) {
        this.$depthSearchTree(node => {
          if (node[this.params.key] === e.node.dataRef[this.params.key]) {
            this.initPath(node.children, node);
          }
        }, this.data);
        this.$emit('load', e.node.dataRef);
      },
      handleCheck(data, e) {
        if (this.checkStrictly) {
          // 父子不关联
          if (e.checked) {
            this.add(e.node.dataRef);
          } else {
            this.del(this.value.findIndex(value => value[this.params.key] === e.node.dataRef[this.params.key]));
          }
        } else {
          // 父子关联
          let result = [];
          let halfResult = [];
          this.$depthSearchTree(node => {
            if (data.indexOf(node[this.params.key]) > -1) {
              result.push(node);
            }
            if (e.halfCheckedKeys.indexOf(node[this.params.key]) > -1) {
              halfResult.push(node);
            }
          }, this.data);
          this.$emit('input', result);
          this.$emit('changeHalfCheckedData', halfResult);
        }
      },
      add(data) {
        if (!this.multiple) {
          this.value.splice(0, 1);
        }
        this.value.push(data);
        this.$emit('input', this.value);
      },
      del(index) {
        this.value.splice(index, 1);
        this.$emit('input', this.value);
      }
    },
  }
</script>

<style lang="less" scoped>
  @import '../assets/styles/tools.less';
  .tree-select {
    
  }
</style>